import React, { useState } from "react";
import { Space, Descriptions, Tag, Button, Modal } from "antd";
import { EvaluationData } from "../EvaluationData";
import StepHeader from "../StepHeader";
import { SearchOutlined, CloseOutlined } from "@ant-design/icons";
import EditSentinelForm from "../../Sentinel/EditSentinelForm";
import { Sentinel } from "../../../model_gen/sentinel";
import dayjs from "dayjs";

interface ReviewProps {
  evaluationData: EvaluationData;
}

const Review: React.FC<ReviewProps> = ({ evaluationData }) => {
  const [isEditSentinelModalVisible, setIsEditSentinelModalVisible] = useState(false);
  const [selectedSentinel, setSelectedSentinel] = useState<Sentinel | null>(null);

  const handleViewSentinel = (sentinel: any, e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    setSelectedSentinel(sentinel);
    setIsEditSentinelModalVisible(true);
  };

  const renderSentinelTag = (sentinel: any) => {
    return (
      <Tag 
        key={sentinel.id} 
        color="blue"
        style={{ marginRight: 3 }}
      >
        <span style={{ marginRight: 8 }}>
          {sentinel.sentinel_name}
        </span>
        <Button
          icon={<SearchOutlined />}
          size="small"
          type="text"
          onClick={(e) => handleViewSentinel(sentinel, e)}
          style={{ cursor: "pointer" }}
        />
      </Tag>
    );
  };


  return (
    <>
      <Space direction="vertical" size="large" style={{ width: "100%" }}>
        <StepHeader
          title="Review Evaluation Settings"
          description="Review your evaluation configuration before running"
        />

        <Descriptions 
          bordered 
          column={1}
          size="middle"
          labelStyle={{ width: "200px", background: "#fafafa" }}
        >
          <Descriptions.Item label="Date Range">
            {evaluationData.dateStart && evaluationData.dateEnd ? (
              `${dayjs(evaluationData.dateStart).format("YYYY-MM-DD")} to ${dayjs(evaluationData.dateEnd).format("YYYY-MM-DD")}`
            ) : (
              "Not set"
            )}
          </Descriptions.Item>
          
          <Descriptions.Item label="Application">
            {evaluationData.application?.application_name || "Not selected"}
          </Descriptions.Item>
          
          <Descriptions.Item label="Intent">
            {evaluationData.intent?.action_type || "Not selected"}
          </Descriptions.Item>
          
          <Descriptions.Item label="Selected Sentinels">
            {evaluationData.sentinels.length > 0 ? (
              <Space wrap size="small">
                {evaluationData.sentinels.map(sentinel => renderSentinelTag(sentinel))}
              </Space>
            ) : (
              "No sentinels selected"
            )}
          </Descriptions.Item>
        </Descriptions>
      </Space>

      <Modal
        visible={isEditSentinelModalVisible}
        onCancel={() => {
          setIsEditSentinelModalVisible(false);
          setSelectedSentinel(null);
        }}
        footer={null}
        width={800}
        title="Sentinel"
        closeIcon={<CloseOutlined />}
      >
        {selectedSentinel && (
          <EditSentinelForm
            key={selectedSentinel.id}
            sentinel={selectedSentinel}
            loading={false}
            isDataLoaded={true}
            onSubmit={() => {}} // Read-only mode
            onClose={() => {
              setIsEditSentinelModalVisible(false);
              setSelectedSentinel(null);
            }}
            readOnly={true}
          />
        )}
      </Modal>
    </>
  );
};

export default Review;
